import { whyPoints } from "@/data/content";

export const WhyDigivili = () => {
  return (
    <section id="miksi" className="py-16 sm:py-24 bg-[#F3EFE7]">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <span className="text-base font-bold text-[#245037] uppercase tracking-wide">
            Miksi Digivili
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#1C1917]">
            Kärsivällistä apua, jolla on kasvot
          </h2>
          <div className="mt-8 space-y-6">
            {whyPoints.map((w, i) => {
              const Icon = w.icon;
              return (
                <div key={i} data-testid={`why-point-${i}`} className="flex gap-4">
                  <div className="w-12 h-12 shrink-0 rounded-xl bg-[#245037] flex items-center justify-center">
                    <Icon strokeWidth={2.5} className="w-6 h-6 text-[#E8C88A]" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#1C1917]">{w.title}</h3>
                    <p className="mt-1 text-base leading-relaxed text-[#44403C]">{w.text}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="relative">
          <div className="absolute -inset-4 bg-[#E8C88A]/30 rounded-[2rem] -rotate-2" />
          <img
            src="https://images.pexels.com/photos/6874441/pexels-photo-6874441.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Tyytyväinen seniori soittaa videopuhelua tabletilla"
            className="relative rounded-[2rem] shadow-lg w-full h-[440px] object-cover"
          />
        </div>
      </div>
    </section>
  );
};
